const mandatoryFields = ['date', 'location', 'home_team_id', 'away_team_id'];

export default mandatoryFields;
